import React from 'react';
import Grid from "@material-ui/core/Grid/Grid";
import Link from '@material-ui/core/Link';
import './styles/footer-styles.scss';
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(() => ({
  link: {
    margin: '3px',
    color: 'white'
  },
}));

const Footer = () => {
  const classes = useStyles();

  return (
    <div className='footer'>
      <Grid container justify="space-between" alignItems='center'>
        <Grid item style={{ marginLeft: '2%' }} xs={5}>
          <div>
            <h4>Need help?</h4>
            <p>Contact us at 877.335.7589 or</p>
            <p style={{ marginTop: 0 }}><b><Link href="mailto:solutioncenter@pltw.org" className={classes.link}>solutioncenter@pltw.org</Link></b></p>
          </div>
        </Grid>
        <Grid item style={{ marginRight: '4%' }} xs={6}>
          <Grid container direction="column" alignItems="flex-end">
              <Link target='_blank' href='https://www.pltw.org' className={classes.link}>PLTW.org</Link>
              <Link target='_blank' href='https://www.pltw.org/program-support' className={classes.link}>Additional Resources</Link>
              <Link target='_blank' href='https://www.pltw.org/terms-of-service' className={classes.link}>Terms of Service</Link>
              <Link target='_blank' href='https://www.pltw.org/privacy-policy' className={classes.link}>Privacy Policy</Link>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default Footer;
